import styled from 'styled-components';

export const InnerWrapper = styled.section`
  width: 100%;
`;

export const TextWrapper = styled.section`
  width: 96%;
  padding: 2em 2%;
  display: flex;
  flex-direction: column;
  gap: 1em;
  h1 {
    font-size: 1.8em;
    text-align: center;
    font-weight: 700;
  }
  h2 {
    font-size: 1.75em;
    text-align: center;
  }
  @media (max-width: 1200px) {
    h1 {
      // font-size: 1.2em;
    }
    p {
      // font-size: 1em;
    }
  }
`;

export const SubTextWrapper = styled(TextWrapper)`
  background: #382336;
  color: #ffffff;
`;

export const ButtonWrapper = styled.section`
  display: flex;
  justify-content: center;
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
`;
